var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "hide-footer": "",
        "header-close-label": _vm.$t("Btn_Close")
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function() {
            return [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("ContinuousReportSummary.Notes.DialogTitle"))
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "mb-3 font-italic" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("ContinuousReportSummary.Notes.Disclaimer")))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.notes, function(sectionNotes, sectionTitle) {
            return _c(
              "div",
              { key: sectionTitle + "-notes", staticClass: "mb-3" },
              [
                _c("div", { staticClass: "bold mb-2" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t(sectionTitle)))])
                ]),
                _vm._v(" "),
                _vm.filteredSectionNotes(sectionNotes).length === 0
                  ? _c("div", [
                      _c("span", { staticClass: "font-italic" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("ContinuousReportSummary.Notes.NoNotes")
                          )
                        )
                      ])
                    ])
                  : _vm._l(_vm.filteredSectionNotes(sectionNotes), function(
                      note,
                      i
                    ) {
                      return _c(
                        "div",
                        {
                          key: "note-" + i,
                          staticClass: "d-flex flex-column mb-3 ml-3"
                        },
                        [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("ContinuousReport.Period." + note.period)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(note.text))])
                        ]
                      )
                    })
              ],
              2
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }